// ============================================================
// ASTRAEA ASTROLOJİ — Site İçerik Yapılandırması
// Bu dosyadan iletişim bilgilerini, fiyatları ve metinleri kolayca
// değiştirebilirsiniz. Kendi fotoğraflarınızı eklemek için
// /app/frontend/public/images/ klasörüne dosyayı koyup aşağıdaki
// portrait alanlarına "/images/dosya-adiniz.jpg" yazmanız yeterli.
// ============================================================

export const BRAND = {
  name: "NEKSUS",
  astrologer: "Nazife Cankaya Güder",
  tagline: "Numeroloji Eğitimleri & Bireysel Danışmanlık",
  copyright: "© 2026 Neksus. Tüm Hakları Saklıdır.",
};

// Fotoğraflar: kendi görsellerinizi public/images/ içine koyup
// buraya "/images/dosya-adiniz.jpg" gibi yol yazın.
export const IMAGES = {
  heroPortrait: "/images/portre-yesil.jpg",
  aboutPortrait: "/images/portre-gulus.jpg",
  aboutOverlap: "/images/portre-mavi.jpg",
  contactPortrait: "/images/portre-beyaz.jpg",
  logoN: "/images/logo-n.png",
  logoWordmark: "/images/logo-wordmark.jpg",
  eduBanner: "/images/banner-akademi.jpg",
  consultBanner: "/images/banner-danismanlik.jpg",
  sinastriBanner: "/images/banner-sinastri.jpg",
  cocukBanner: "/images/banner-cocuk.jpg",
  ongoruBanner: "/images/banner-ongoru.jpg",
  isimBanner: "/images/banner-isim.jpg",
  bebekBanner: "/images/banner-bebek.jpg",
  ortaklikBanner: "/images/banner-ortaklik.jpg",
  neksusBanner: "/images/banner-neksus.jpg",
  atolyeBanner: "/images/banner-atolye.jpg",
};

export const CONTACT = {
  whatsappNumber: "905400012588", // Ülke koduyla, boşluksuz
  whatsappDisplay: "+90 540 001 25 88",
  instagram: "@nazifecankayaguder",
  instagramUrl: "https://instagram.com/nazifecankayaguder",
  email: "info@neksusmerkezi.com",
};

export const waLink = (message) =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(message)}`;

// PayTR ödeme linkleri: PayTR Mağaza Paneli → "Link ile Ödeme" bölümünden her
// ürün için oluşturduğunuz linkleri buraya ekleyin. Bir ürünün birden fazla
// ödeme seçeneği (tek çekim / taksit) olabilir. Liste boşsa buton WhatsApp'a döner.
export const PAYMENT_LINKS = {
  "temel-orta-seviye": [],
  "ileri-ongoru": [],
  "sinastri-uzmanlik": [],
  "ws-1": [],
  "ws-2": [],
  "numeroloji-egitimi": [],
  numeroloji: [
    { label: "Tek Çekim · 6.380 ₺", url: "https://www.paytr.com/link/JbDYvaY" },
    { label: "2 Taksit · 6.560 ₺", url: "https://www.paytr.com/link/kowXicE" },
    { label: "3 Taksit · 6.740 ₺", url: "https://www.paytr.com/link/WJrzS20" },
  ],
};

export const paymentLinksFor = (productId) => PAYMENT_LINKS[productId] || [];

export const HERO = {
  eyebrow: "Profesyonel Astroloji Eğitimi & Danışmanlık",
  lines: ["Astrolojiyi Keşfedin.", "Kendinizi Anlayın.", "Gökyüzünü Okuyun."],
  subtext:
    "Kadim gökyüzü bilgeliğini modern psikolojik yaklaşım ve metodolojik harita okuma teknikleriyle birleştirerek hayat yolculuğunuza ışık tutuyorum.",
  stats: [
    { value: "10+", label: "Yıllık Deneyim" },
    { value: "1000+", label: "Danışmanlık" },
    { value: "300+", label: "Mezun Öğrenci" },
  ],
};

export const MARQUEE_ITEMS = [
  "DOĞUM HARİTASI ANALİZİ",
  "TEMEL & İLERİ ASTROLOJİ EĞİTİMİ",
  "ÖNGÖRÜ TEKNİKLERİ",
  "İLİŞKİ ASTROLOJİSİ (SİNASTRİ)",
  "TUTULMALAR & RETROLAR",
  "BİREBİR AKADEMİK REHBERLİK",
];

export const ABOUT = {
  chapter: "01",
  label: "HAKKIMDA",
  title: "Astroloğunuz İle Tanışın",
  paragraphs: [
    "Astroloji, kaderin kaçınılmaz bir yazgısı değil; potansiyellerimizi, zamanlama döngülerimizi ve öz benliğimizi anlama sanatıdır. 10 yılı aşkın uluslararası sertifikalı pratiğimde yüzlerce danışana rehberlik ettim ve yüzlerce öğrenci yetiştirdim.",
    "Yaklaşımım sade, sistemli ve öğreticidir: mistik söylemler yerine haritanızın dilini anlaşılır, uygulanabilir ve hayatınıza dokunan bir çerçeveye oturturum.",
  ],
  quote: "Gökyüzü bir tehdit değil, bir zamanlama haritasıdır.",
  highlights: [
    "ISAR & NCGR Sertifikalı Astrolog",
    "Psikolojik ve Klasik Astroloji Yaklaşımı",
    "1000+ Bireysel Danışmanlık Deneyimi",
    "Kişiselleştirilmiş Eğitim Müfredatı",
  ],
};

export const EDUCATION = {
  chapter: "02",
  label: "EĞİTİMLER",
  title: "Eğitim Programları",
  subtext:
    "Sıfırdan uzmanlığa planlanmış, uygulama odaklı, canlı derslerle desteklenen eğitim programları.",
  packages: [
    {
      id: "numeroloji-egitimi",
      badge: "Kayıtlar Açık",
      title: "Numeroloji Eğitimi",
      description:
        "5 Kasım 2026'da başlayan kapsamlı program: sayıların dilini öğrenerek kendinizi ve çevrenizdekileri derinlemesine okuyabileceğiniz keyifli ve verimli bir 16 hafta.",
      duration: "16 Hafta · 5 Kasım 2026 başlangıç",
      format: "Online Canlı Dersler",
      price: "Kayıtlar Açık",
      priceNote: "fiyat ve kayıt için WhatsApp'tan yazın",
      cta: "Bilgi Al",
      waMessage:
        "Merhaba, 5 Kasım'da başlayacak Numeroloji Eğitimi hakkında bilgi almak istiyorum.",
      testId: "education-card-1",
    },
  ],
};

export const CONSULTATIONS = {
  chapter: "03",
  label: "DANIŞMANLIKLAR",
  title: "Bireysel Danışmanlıklar",
  subtext:
    "Kişisel haritanız üzerinden kendinizi daha yakından tanıyacağınız, potansiyellerinizi keşfedeceğiniz birebir çalışmalar.",
  services: [
    {
      id: "numeroloji",
      title: "Numeroloji Danışmanlığı",
      description:
        "Kişisel numeroloji haritanız üzerinden kendinizi daha yakından tanımaya, potansiyellerinizi keşfetmeye ve yaşamınıza farklı bir pencereden bakmaya alan açan kapsamlı bir danışmanlık çalışması.",
      duration: "Tek çekim · Kapsamlı danışmanlık",
      price: "6.380 ₺",
      waMessage: "Merhaba, Numeroloji Danışmanlığı hakkında bilgi almak istiyorum.",
      testId: "consultation-card-1",
    },
  ],
};

export const WORKSHOPS = {
  chapter: "04",
  label: "ETKİNLİKLER",
  title: "Yaklaşan Eğitimler & Atölyeler",
  subtext: "Yeni dönem eğitim ve atölye duyuruları.",
  items: [
    {
      id: "numeroloji-egitimi",
      day: "05",
      month: "KASIM 2026",
      time: "16 Hafta · Online Canlı",
      name: "Numeroloji Eğitimi — Yeni Dönem Başlangıcı",
      description:
        "Sayıların dilini sıfırdan öğreneceğiniz, birlikte keyifli ve verimli geçireceğimiz 16 haftalık kapsamlı numeroloji programı başlıyor.",
      spots: "Kayıtlar açık",
      price: "Kayıt için yazın",
      waMessage: "Merhaba, 5 Kasım'da başlayacak Numeroloji Eğitimi'ne kaydolmak istiyorum.",
      testId: "workshop-item-1",
    },
  ],
};

export const TESTIMONIALS = {
  chapter: "05",
  label: "YORUMLAR",
  title: "Öğrenci & Danışan Deneyimleri",
  items: [
    {
      quote:
        "Temel Seviye eğitimini tamamladığımda kendi haritamı okuyabilecek seviyeye geldim. Anlatım o kadar duru ve sistemli ki karmaşık gelen tüm gezegen açıları zihnimde oturdu.",
      name: "Zeynep K.",
      role: "Astroloji Öğrencisi",
    },
    {
      quote:
        "Harita analizim, kariyer değişim dönemimde bana inanılmaz bir cesaret ve netlik verdi. Potansiyelimi bu kadar rasyonel bir dille dinlemek harikaydı.",
      name: "Mert S.",
      role: "Danışan · Kurumsal Yönetici",
    },
    {
      quote:
        "İleri öngörü teknikleri dersleri ufkumu açtı. Gerçekleşen transitlerin hayat ritmimle nasıl birebir uyuştuğunu görmek büyüleyici.",
      name: "Selin D.",
      role: "Atölye Katılımcısı",
    },
  ],
};

export const CONTACT_SECTION = {
  chapter: "06",
  label: "İLETİŞİM",
  title: "İletişime Geçin",
  subtext:
    "Eğitim veya danışmanlık süreçleriyle ilgili her türlü sorunuz için bana ulaşın; ya da formu doldurun, en kısa sürede dönüş yapayım.",
  serviceOptions: ["Astroloji Eğitimi", "Bireysel Danışmanlık", "Atölye / Webinar", "Diğer"],
};

export const LEGAL = {
  privacy: {
    title: "Gizlilik Politikası",
    body: [
      "Bu web sitesi üzerinden paylaştığınız ad, e-posta ve telefon bilgileri yalnızca talebinize yanıt vermek ve randevu süreçlerini yönetmek amacıyla kullanılır.",
      "Bilgileriniz üçüncü kişilerle paylaşılmaz, satılmaz ve pazarlama amaçlı başka platformlara aktarılmaz. Dilediğiniz zaman verilerinizin silinmesini talep edebilirsiniz.",
      "Danışmanlık görüşmelerinde paylaşılan tüm kişisel bilgiler ve doğum verileri gizlilik ilkesi çerçevesinde korunur.",
    ],
  },
  terms: {
    title: "Kullanım Şartları",
    body: [
      "Astroloji danışmanlıkları ve eğitimleri bilgilendirme ve kişisel farkındalık amaçlıdır; tıbbi, hukuki veya finansal tavsiye niteliği taşımaz.",
      "Eğitim kayıtlarında ücret iadesi, program başlangıcından 7 gün öncesine kadar yapılabilir. Atölye kayıtları bir sonraki etkinliğe devredilebilir.",
      "Randevunuza katılamayacağınız durumlarda en geç 24 saat önceden bilgilendirme yapmanız rica olunur.",
    ],
  },
};
